import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ChangePassword.css";
import { MagasinContext } from "../../../Context/MagasinContext";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";
import MagasinInfoService from "../../../Services/Magasin/MagasinInfo";
import axios from "axios";

export default function ChnageMailMagasin() {
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");
  const id = MagasinId || magasinContext.id?.id;
  const navigate = useNavigate();

  const [currentEmail, setCurrentEmail] = useState("");
  const [loadingEmail, setLoadingEmail] = useState(true);
  const [password, setPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [popup, setPopup] = useState<{ visible: boolean; title: string; message: string; type: "success" | "error" }>({
    visible: false, title: "", message: "", type: "success"
  });

  /* Fetch the real current email from the API */
  useEffect(() => {
    if (id) {
      MagasinInfoService(id)
        .getMagasinInfo()
        .then((res: any) => {
          // The API returns an array of magasins, take the first one
          const magasin = Array.isArray(res.data) ? res.data[0] : res.data;
          if (magasin) {
            setCurrentEmail(magasin.email || magasin.Email || magasin.CompteEmail || "");
          }
          setLoadingEmail(false);
        })
        .catch(() => {
          setCurrentEmail("");
          setLoadingEmail(false);
        });
    }
  }, [id]);

  const handleGoBack = () => navigate(-1);

  /* Basic email format check */
  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async () => {
    if (!password) {
      setPopup({ visible: true, title: "Erreur", message: "Veuillez entrer votre mot de passe actuel.", type: "error" });
      setTimeout(() => setPopup(prev => ({...prev, visible: false})), 3000);
      return;
    }
    if (!newEmail || !isValidEmail(newEmail)) {
      setPopup({ visible: true, title: "Erreur", message: "Veuillez entrer une nouvelle adresse email valide.", type: "error" });
      setTimeout(() => setPopup(prev => ({...prev, visible: false})), 3000);
      return;
    }

    setLoadingSubmit(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/request-change-email`, {
        password: password,
        new_email: newEmail
      });
      setPopup({ visible: true, title: "Succès", message: response.data.success || "Votre demande a été envoyée. Veuillez patienter 24 heures et nous vous recontacterons.", type: "success" });
      setPassword("");
      setNewEmail("");
    } catch (error: any) {
      const errorMsg = error.response?.data?.error || "Une erreur est survenue. Veuillez réessayer.";
      setPopup({ visible: true, title: "Erreur", message: errorMsg, type: "error" });
    } finally {
      setLoadingSubmit(false);
      setTimeout(() => setPopup(prev => ({...prev, visible: false})), 5000);
    }
  };

  const popupStyle = (type: "success" | "error") => ({
    position: "fixed" as const,
    top: "20px",
    right: "20px",
    zIndex: 9999,
    padding: "20px 24px",
    borderRadius: "16px",
    border: "1px solid #ffffff",
    color: "#ffffff",
    backgroundColor: type === "success" ? "#059669" : "#dc2626",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
    minWidth: "300px",
    animation: "slideInRight 0.3s ease-out",
  });

  return (
    <>
      <NewSideBarMagasins />
      {popup.visible && (
        <div style={popupStyle(popup.type)}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", fontWeight: 700, fontSize: "1.1rem", marginBottom: "8px" }}>
            <i className={`bi bi-${popup.type === "success" ? "check-circle" : "x-circle"}`}></i>
            {popup.title}
          </div>
          <p style={{ margin: 0, paddingLeft: "26px", fontSize: "0.95rem", opacity: 0.9 }}>{popup.message}</p>
        </div>
      )}
      <div className="sf-page">
        <div className="sf-inner">
          {/* Back */}
          <button className="sf-back" onClick={handleGoBack}>
            <i className="bi bi-arrow-left"></i> Retour
          </button>

          {/* Header */}
          <div className="sf-header">
            <div className="sf-header-icon">
              <i className="bi bi-envelope"></i>
            </div>
            <div className="sf-header-text">
              <h1>Changer l'adresse email</h1>
              <p>Mettez à jour l'adresse email associée à votre compte</p>
            </div>
          </div>

          {/* Card */}
          <div className="sf-card">
            {/* Current email display */}
            <div className="sf-group">
              <label className="sf-label">Email actuel</label>
              {loadingEmail ? (
                <div className="sf-email-current">
                  <i className="bi bi-hourglass-split"></i>
                  Chargement...
                </div>
              ) : (
                <div className="sf-email-current">
                  <i className="bi bi-envelope-check"></i>
                  {currentEmail || "Aucun email trouvé"}
                </div>
              )}
            </div>

            <div className="sf-divider"></div>

            {/* Password confirmation */}
            <div className="sf-group">
              <label className="sf-label">Mot de passe</label>
              <div className="sf-input-wrap">
                <i className="bi bi-lock sf-field-icon"></i>
                <input
                  className="sf-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Confirmez votre mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="sf-toggle-vis"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                </button>
              </div>
              <div className="sf-hint">
                <i className="bi bi-info-circle"></i>
                Requis pour confirmer votre identité
              </div>
            </div>

            {/* New email */}
            <div className="sf-group">
              <label className="sf-label">Nouvelle adresse email</label>
              <div className="sf-input-wrap">
                <i className="bi bi-at sf-field-icon"></i>
                <input
                  className="sf-input"
                  type="email"
                  placeholder="Entrez votre nouvelle adresse email"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                />
              </div>
              {newEmail && !isValidEmail(newEmail) && (
                <div className="sf-hint" style={{ color: "#EF4444" }}>
                  <i className="bi bi-exclamation-circle"></i>
                  Veuillez entrer une adresse email valide
                </div>
              )}
              {newEmail && isValidEmail(newEmail) && (
                <div className="sf-hint" style={{ color: "#22C55E" }}>
                  <i className="bi bi-check-circle"></i>
                  Adresse email valide
                </div>
              )}
            </div>

            {/* Actions */}
            <div className="sf-actions">
              <button className="sf-submit" onClick={handleSubmit} disabled={loadingSubmit}>
                {loadingSubmit ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  <>
                    <i className="bi bi-check-lg"></i>
                    Valider le changement
                  </>
                )}
              </button>
              <button className="sf-cancel" onClick={handleGoBack}>
                Annuler
              </button>
            </div>
          </div>

          {/* Help */}
          <div className="sf-help">
            <i className="bi bi-question-circle"></i>
            Besoin d'aide ?&nbsp;
            <a href="/contacter-nous">Contactez-nous</a>
          </div>
        </div>
      </div>
    </>
  );
}